"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const createOrganization_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/createOrganization.graphql"));
const updateOrganization_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/updateOrganization.graphql"));
const deleteOrganizationMember_graphql_1 = tslib_1.__importDefault(require("../gql/organizations/mutations/deleteOrganizationMember.graphql"));
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
class Organization extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = createOrganization_graphql_1.default;
        this.updateMutation = updateOrganization_graphql_1.default;
    }
    defaults() {
        return {
            uuid: '',
            email: '',
            name: '',
            logo: '',
            address: '',
            phone: '',
            website: '',
            owners: [],
            options: [],
        };
    }
    deleteMember({ userUuid }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(deleteOrganizationMember_graphql_1.default, {
                organizationUuid: this.uuid,
                userUuid,
            });
        });
    }
}
exports.default = Organization;
//# sourceMappingURL=Organization.js.map